import React, { useEffect, useState } from 'react';
import UploadMultiDocuments from '@components/UploadMultiDocuments';
import { FileListData } from '@typings/ResidentTypes';
import UploadedFileTable from '@components/UploadedFileTable';
import { LpaType } from '../../utils';

interface LpaUploadProps {
  userId: string;
  lpa: LpaType;
  setLpa: React.Dispatch<React.SetStateAction<LpaType>>;
  lpaFromData: LpaType;
}

const LpaUpload: React.FC<LpaUploadProps> = ({
  userId,
  lpa,
  setLpa,
  lpaFromData,
}) => {
  const [uploadedLpaFileList, setUploadedLpaFileList] = useState<
    FileListData[]
  >([]);

  useEffect(() => {
    setLpa(prev => ({
      ...prev,
      lpaInfo: { ...prev.lpaInfo, uploadedLpaFileList },
    }));
  }, [uploadedLpaFileList, setLpa]);

  useEffect(() => {
    setUploadedLpaFileList(lpaFromData.lpaInfo.uploadedLpaFileList);
  }, [lpaFromData]);

  return (
    <div className="govuk-form-group">
      <h3 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--s" htmlFor="upload-lpa">
          Upload a copy of the Lasting Power of Attorney for health and welfare
        </label>
      </h3>

      <UploadMultiDocuments
        userId={userId}
        fileList={uploadedLpaFileList}
        setFileList={setUploadedLpaFileList}
        uploadInputId="upload-lpa"
        customizedButtonText="Upload LPA"
      />
      {uploadedLpaFileList.length > 0 && (
        <div className="mt-10">
          <UploadedFileTable
            fileList={uploadedLpaFileList}
            setFileList={setUploadedLpaFileList}
          />
        </div>
      )}
    </div>
  );
};

export default LpaUpload;
